import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MediaObjectFit, MediaType } from '@epicuro-next/ataraxia/models';
import {
  AbstractContentComponent,
  ResponsiveInput,
} from '@epicuro-next/elements/content-core';
import { PulseContentElement } from '@epicuro-next/elements/core';

const selector = 'pcn-media';

@PulseContentElement({ selector })
@Component({
  selector,
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaComponent
  extends AbstractContentComponent
  implements OnInit, OnDestroy
{
  @Input() public mediaType = MediaType.IMAGE;

  @ResponsiveInput()
  @Input()
  public src: string;

  @ResponsiveInput({ isBoolean: true, defaultValue: 'false' })
  @Input()
  public autoplay = false;

  @ResponsiveInput({ isBoolean: true, defaultValue: 'true' })
  @Input()
  public muted = true;

  @ResponsiveInput({ isBoolean: true, defaultValue: 'true' })
  @Input()
  public controls = false;

  @ResponsiveInput({ isNumber: true })
  @Input()
  public startVideoAdvancedBy = 3;

  @ResponsiveInput({ isBoolean: true })
  @Input()
  public activateOnMouseEnter = true;

  @ResponsiveInput()
  public objectFit = MediaObjectFit.COVER;

  @ResponsiveInput()
  @Input()
  public maxWidth = 720;

  @ResponsiveInput({ cssVariable: true })
  public objectPosition: string;

  public ngOnInit() {
    super.ngOnInit();
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  public get media() {
    return {
      url: this.src,
      mediaType: this.mediaType,
    };
  }

  public get videoAttributes() {
    return {
      autoplay: this.autoplay,
      muted: this.muted,
      controls: this.controls,
    };
  }
}
